import Modal from "./modal-basic";
import handleModalState from "./handle-modal-state";

export default Modal;
export { handleModalState };
